<template>
    <div>
            <b-form>
                
                <div class="animated fadeIn">
                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Grupo"
                            label-for="group"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="group" v-model="componentItem.name" type="text" style="text-transform: uppercase" :class="groupClass" ></b-form-input>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Dia da semana"
                                label-for="weekday"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-select id="weekday"
                                    v-model="componentItem.weekdayId"
                                    :plain="true"
                                    :options="weekdayDDL"
                                    value=""
                                    :class="weekdayClass"
                                    >
                                </b-form-select>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                                description=""
                                label="Hora"
                                label-for="meetingTime"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-select id="meetingTime"
                                    v-model="componentItem.meetingTime"
                                    :plain="true"
                                    :options="timeDDL"
                                    value=""
                                    :class="meetingTimeClass">
                                </b-form-select>
                                
                            </b-form-group>
                        </b-form>
                        </b-col>
                    </b-row>

                    <hr>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description="Ex: background-color: #b88d42"
                            label="Estilo de Fundo"
                            label-for="backgroundStyle"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="backgroundStyle" v-model="componentItem.backgroundStyle" type="text" ></b-form-input>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description="Ex: color: #fff"
                            label="Fonte"
                            label-for="fontStyle"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="fontStyle" v-model="componentItem.fontStyle" type="text" ></b-form-input>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>
                        
                </div>
            </b-form>

            <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.componentItem.id && this.componentItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.componentItem.id && this.componentItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    -->
                    <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Grupo</span></b-button>
                    
            </div>
    </div>  

</template>


<script>
import Vue from 'vue'
import axios from "axios";
import MaskedInput from 'vue-text-mask'

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
    name: 'documentTemplatePdfComponent',
    props: {
       item: {},
       companyId: 0
    },
    components: {
      MaskedInput
    },
    data: () => {
        return {          
            groupClass: '',
            meetingTimeClass: '',
            weekdayClass: '',

            weekdayDDL: [],
            timeDDL: []
        }
    },
    computed: {
        componentItem() {
            return this.item
        }
    },
    methods: {
        save() {
            let msgError = [];

            this.groupClass = (this.componentItem.name.length <= 2) ? 'is-invalid' : ''
            this.weekdayClass = (!this.componentItem.weekdayId || this.componentItem.weekdayId <= 0) ? 'is-invalid' : ''
            this.meetingTimeClass = (!this.componentItem.meetingTime || this.componentItem.meetingTime <= 0) ? 'is-invalid' : ''

            if(this.componentItem.name.length <= 2) {
                this.groupClass = (this.componentItem.name.length <= 2) ? 'is-invalid' : ''
                msgError.push("Grupo");
            }
                
            if(!this.componentItem.weekdayId || this.componentItem.weekdayId <= 0) {
                msgError.push("Dia da semana");
                this.weekdayClass = (!this.componentItem.weekdayId || this.componentItem.weekdayId <= 0) ? 'is-invalid' : ''
            }
            
            if(!this.componentItem.meetingTime || this.componentItem.meetingTime <= 0) {
                this.meetingTimeClass = (!this.componentItem.meetingTime || this.componentItem.meetingTime <= 0) ? 'is-invalid' : ''
                msgError.push("Hora");
            }

            if(msgError.length > 0) {
                /*
                let msgErrorExt = "Verifique os campos: ";
                let msgErrorSep = "";
                msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

                toast ({
                    type: VueNotifications.types.error,
                    title: 'Grupo',
                    message: msgErrorExt,
                    timeout: 5000
                })
                */
            }
            else {
                this.saveItem(this.componentItem);
            }
        },
        
        async saveItem(currentItem) {

            var s = this;
            var postData = {...currentItem};

            postData["companyId"] = this.companyId
            postData["uid"] = this.$store.state.currentUser.id,
            postData["sid"] = this.$store.state.currentUser.sid

            await axios.post(
                this.$store.state.ws_url + "/franchise/group",
                postData
            ).then(function() {
                s.$emit('response', { code: 1, message: 'Grupo incluido/alterado.'})
            }
            ).catch(function (error) {
                console.log(error);

                toast ({
                    type: VueNotifications.types.warn,
                    title: 'Grupo',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 5000
                })        
            });
        },

        async refreshWeekday() {
            var s = this;
            await axios.get(
                this.$store.state.ws_url + "/weekday/ddl"
            )
            .then(function(resp) {
                s.weekdayDDL = resp.data.obj
            }).catch(function(error) {
                s.weekdayDDL = []
                console.log(error)
            })
        },

        async refreshTime() {
            var s = this;
            await axios.get(
                this.$store.state.ws_url + "/time?startHour=8&endHour=19&minutesInterval=30"
            )
            .then(function(resp) {
                s.timeDDL = resp.data.obj
            }).catch(function(error) {
                s.timeDDL = []
                console.log(error)
            })
        }
        
       
    },
    mounted: function() {
        this.refreshWeekday()
        this.refreshTime()
    }
}
</script>